.root {
	border-bottom: 1px solid var(--ds-border, var(--adg3-color-N50));
	padding: calc(var(--jpo-common-base-spacing));
	position: relative;
	display: flex;
	justify-content: space-between;
}

.titleBar {
	display: flex;
	align-items: center;
}

.planTitle {
	font-size: 24px;
	color: var(--ds-text, var(--jpo-text-default-color));
	max-width: 700px;
	text-overflow: ellipsis;
	word-break: break-all;
	white-space: nowrap;
	overflow: hidden;
	line-height: 1.475;
	padding: var(--jpo-common-base-spacing) 0px;
}

.scenario {
	display: flex;
	color: var(--ds-text-subtle, var(--adg3-color-N400));
	margin-left: 20px;
	margin-top: 5px;
	align-items: center;
}

.scenarioColor {
	height: 14px;
	width: 14px;
	border-radius: 3px;
	margin-right: 5px;
}

.scenarioTitle {
	flex: 1 0 auto;
	max-width: 500px;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
	text-align: start;
}

.logoContainer {
	color: var(--ds-icon-accent-blue, var(--adg3-color-B300));
	display: flex;
	align-items: center;
}
